import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userDetail: "",
  blockUser:{}, 
  isLoading: false, // Add isLoading property to the initial state
};

const adminUser = createSlice({
  name: "adminUser",
  initialState,
  reducers: {
    // using action for users
    getUserByIdRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when login request starts
    },
    getUserByIdSuccess: (state, action) => {
      state.userDetail = action.payload;
      state.isLoading = false; // Set isLoading to false after successful login
    },
    getUserByIdFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if login fails
    },

    // using action for Block users
    getUserBlockRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when login request starts
    },
    getUserBlockSuccess: (state, action) => {
      state.blockUser = action.payload;
      state.isLoading = false; // Set isLoading to false after successful login
    },
    getUserBlockFailure: (state) => {
      state.isLoading = false; // Set isLoading to false if login fails
    },
  },
});

export const {
  getUserByIdRequest,
  getUserByIdSuccess,
  getUserByIdFailure,
  getUserBlockRequest,
  getUserBlockSuccess,
  getUserBlockFailure,
} = adminUser.actions;

export default adminUser.reducer;
